import axios from "../api";

export const checkRechargeToken = async (key: string) => {
  return await axios.post("/ConfigService/api/Home/CheckRechargeToken", {
    Token: key,
  });
};
